<template>
    <el-container class="ysxkShowmore">
        <el-main class="gcfhDiv">
            <div>
                <div class="HeadTime">
                    <el-link :underline="false">时间：</el-link>
                    <el-link  :style="{color: item.color}"  v-for="item in TimeInfo" :underline="false" @click="showByDate(item)">{{item.title}}</el-link>
                </div>
                <div class="HeadTime">
                    <el-link :underline="false" >类型：</el-link>
                    <el-link :style="{color: item.color}"  v-for="item in TypeInfo"  :underline="false" @click="showByType(item)">{{item.title}}</el-link>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="box">
                <el-card class="box-card">
                    <el-form :inline="true" :model="formInline" label-width="110px" class="demo-form-inline">
                        <el-row>
                            <el-form-item label="项目名称">
                                <el-input v-model="formInline.xmmc" placeholder="请输入项目名称"></el-input>
                            </el-form-item>
                            <el-form-item label="许可证号">
                                <el-input v-model="formInline.xkzh" placeholder="请输入许可证号"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="售房单位">
                                <el-input v-model="formInline.sfdw" placeholder="输入售房单位的名称"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="cxzxClass2">
                                    <el-button type="primary" @click="onSubmit">查询</el-button>
                                    <el-button @click="resetHt">重置</el-button>
                                </div>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </el-card>
            </div>
            <el-tabs v-model="activeName_ysgs" class="ysxkgs_tabs">
                <el-tab-pane label="预售许可公示" name="first"  class="spfTabs">
                    <el-row class="row-con ysxkgsShowMore" v-for="item in tableData" >
                        <el-card class="box-card"  @click.native="showMoreXx(item.id,item.xkzh)">
                            <el-col :span="6" class="YsxkgsImg">
                                <el-image
                                        :src="item.imgUrl"
                                ></el-image>
                            </el-col >
                            <el-col :span="9">
                                <el-row >
                                    <span class="ysxkcontent1">
                                    项目名称：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.xmmc}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    地址坐落：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.dzzl}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    许可证号：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.xkzh}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    资金监管银行：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.zjjgyh}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    银行账户：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.yhzh}}
                                </span>
                                </el-row>
                            </el-col>
                            <el-col :span="9">
                                <el-row>
                                    <span class="ysxkcontent1">
                                    售房单位：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.sfdw}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    规划用途：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.ghyt}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    拟开盘时间：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.nkpsj}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    土地使用证号：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.tdsyzh}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    总套数：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.zts}}
                                </span>
                                </el-row>
                            </el-col>
                        </el-card>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="现售备案公示" name="second">
                    <el-row class="row-con ysxkgsShowMore" v-for="item in tableData" >
                        <el-card class="box-card"  @click.native="showMoreXx(item.id,item.xkzh)">
                            <el-col :span="6">
                                <el-image
                                        :src="item.imgUrl"
                                ></el-image>
                            </el-col >
                            <el-col :span="9">
                                <el-row >
                                    <span class="ysxkcontent1">
                                    项目名称：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.xmmc}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    地址坐落：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.dzzl}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    许可证号：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.xkzh}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    土地使用证号：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.tdsyzh}}
                                </span>
                                </el-row>
                            </el-col>
                            <el-col :span="9">
                                <el-row>
                                    <span class="ysxkcontent1">
                                    售房单位：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.sfdw}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    规划用途：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.ghyt}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    拟开盘时间：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.nkpsj}}
                                </span>
                                </el-row>
                                <el-row>
                                    <span class="ysxkcontent1">
                                    总套数：
                                </span>
                                    <span class="ysxkcontent2">
                                    {{item.zts}}
                                </span>
                                </el-row>
                            </el-col>
                        </el-card>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
            <div style="text-align: center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        prev-text="上一页"
                        next-text="下一页"
                        :small="true"
                        :page-size="pagesize"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="totalCount"
                >
                </el-pagination>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
    export default {
        name: "spf_showmore",
        data() {
            /*获取预售及现售备案*/
            const ysxs = this.$route.query.ysxs;
            const item = {
                id:1,
                xmmc: '颐和府',
                dzzl: '玄武区中山东路301号',
                xkzh:'邢房预售证第0929号',
                zjjgyh:'中国农业银行',
                yhzh:'63483894930490',
                sfdw:'汉中市某某公司',
                ghyt:'住宅',
                nkpsj:'2020-11-11',
                tdsyzh:'陕-汗6SD5656S',
                zts:'1234',
                imgUrl: require("../img2/spf/ShowMoreYsxk.jpg"),
            };
            const item3 = {
                xqmc: '顺华府',
                fwcount: '2223',
                address: '玄武区中山东路302号',
                fwno:'202040034W',
                bank:'中国农业银行',
                yhzh:'63483894930490',
            };
            return {
                ysxs: this.$route.query.ysxs,
                currentPage:1, //初始页
                pagesize:8,    //    每页的数据
                totalCount:0,
                papercount:8,
                tableData: [],
                tableData3: Array(8).fill(item3),
                activeName_ysgs:ysxs=="xsba"?"second":'first',
                showTime:true,
                TimeClass:'',
                TypeClass:'',
                formInline: {
                    xmmc:'',
                    xkzh: '',
                    sfdw: ''
                },
                TimeInfo: [
                    {
                        imgUrl: 'oneWeek',
                        title: '一周内',
                        color: 'black',
                        times: 7
                    },
                    {
                        imgUrl:'oneMonth',
                        title: '一个月内',
                        color: 'black',
                        times: 30
                    },
                    {
                        imgUrl:'threeMonth',
                        title: '三个月内',
                        color: 'black',
                        times: 90
                    },
                    {
                        imgUrl:'sixMonth',
                        title: '六个月内',
                        times: 180
                    },
                    {
                        imgUrl:'oneYear',
                        title: '一年内',
                        color: 'black',
                        times: 365
                    },
                    {
                        imgUrl:'oneYearAgo',
                        title: '一年前',
                        color: 'black',
                        times: -1
                    },
                ],
                TypeInfo: [
                    {
                        imgUrl: 'zz',
                        title: '住宅',
                        color: 'black',
                    },
                    {
                        imgUrl:'gy',
                        title: '公寓',
                        color: 'black',
                    },
                    {
                        imgUrl:'sy',
                        title: '商业',
                        color: 'black',
                    },
                    {
                        imgUrl:'xzl',
                        title: '写字楼',
                        color: 'black',
                    },
                    {
                        imgUrl:'bs',
                        title: '别墅',
                        color: 'black',
                    },
                    {
                        imgUrl:'cw',
                        title: '车位/车库',
                        color: 'black',
                    },
                ],
                times: 0,
                ghyt: '全部'
            }
        },
        watch: {
            activeName_ysgs() {
                this.totalCount = 0;
                this.tableData = [];
                this.currentPage = 1;
                this.ysxs = (this.activeName_ysgs == 'first' ? 'ysxk' : 'xsba');
                this.handleUserList();
            }
        },
        methods: {
            ...mapActions([
                'Ymxxinit',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            resrtActityIndex(obj){
                this.activeIndex = obj;
            },
            /*根据参数不同显示不同预售信息*/
            showByDate(obj){
                //修改颜色属性
                for (let i of this.TimeInfo) {
                    i.color='black';
                }
                obj.color = '#2BA2F5';
                console.log(obj.times);
                this.times = obj.times;
                this.handleUserList();
            },
            /*根据参数不同显示不同预售信息*/
            showByType(obj){
                //修改颜色属性
                for (let i of this.TypeInfo) {
                    i.color='black';
                }
                obj.color = '#2BA2F5';
                this.ghyt = obj.title;
                this.handleUserList();
            },
            onSubmit() {
                if(this.formInline.xmmc !=""||this.formInline.xkzh!=""||this.formInline.sfdw!=""){
					this.handleUserList();
                }else{
                    this.warnMessage("搜索条件不能为空");
                }
            },
            resetHt(){
                this.formInline.xmmc='';
                this.formInline.xkzh='';
                this.formInline.sfdw='';
                this.handleUserList();
            },
            // 初始页currentPage、初始每页数据数pagesize和数据data
            handleSizeChange: function (size) {
                this.pagesize = size;
                console.log(this.pagesize)  //每页下拉显示数据
            },
            handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                console.log(this.currentPage)  //点击第几页
                this.handleUserList();
            },
            handleUserList() {
                this.Ymxxinit({_module:'TT',_method:'spfmore_ysxkgs',"numPerPage": this.pagesize,"pageNum": this.currentPage, times: this.times, ghyt: this.ghyt, ysxs: this.ysxs, xmmc: this.formInline.xmmc, xkzh: this.formInline.xkzh, sfdw: this.formInline.sfdw}).then((res) => {  //这是从本地请求的数据接口，
                    console.log(res);
                    if (res._page.results !=null ) {
                        for (let i = 0; i < res._page.results.length; i++) {
                            res._page.results[i].imgUrl = require("../img2/spf/ShowMoreYsxk.jpg");
                        }
                        this.tableData=res._page.results;
                    }
                    this.totalCount=res._page.count;
                })
            },
            showMoreXx(id,xkzh){
                if(this.activeName_ysgs=="first"){
                    this.$router.push({path:'/ywhome/spfhome/ysxkshowmoreXx',query:{id:id,xssx:xkzh}})
                }else{
                    this.$router.push({path:'/ywhome/spfhome/xsbashowmoreXx',query:{id:id,xssx:xkzh}})
                }
            }
        },
        created() {
            // 预售许可公示列表
            if(this.activeName_ysgs=="second"){
                this.handleUserList();
            }else{
                this.Ymxxinit({_module:'TT',_method:'spfmore_ysxkgs',"numPerPage": this.pagesize,"pageNum": 1, times: this.times, ghyt: this.ghyt}).then((res) => {
                    console.log(res);
                    if (res._page.results == null || res._page.results.length == 0) {
                        return;
                    }
                    if (res._page.results !=null ) {
                        for (let i = 0; i < res._page.results.length; i++) {
                            res._page.results[i].imgUrl = require("../img2/spf/ShowMoreYsxk.jpg");
                        }
                        this.tableData=res._page.results;
                    }
                    this.totalCount=res._page.count;
                })
            }

        }
    }
</script>

<style scoped>
    @import "../assets/css/spf/spfmore_main.css";
    /*移动端样式*/
    @media screen and (max-width: 414px) {
        .ysxkShowmore .el-main{
            padding: 0 14px;
        }
    }
    /*PC端样式*/
    @media screen and (min-width: 414px) {
        .ysxkShowmore{
            width: 82%;
            margin: auto;
        }
    }
    .HeadTime{
        line-height: 2;
    }
    .HeadTime a{
        margin-right: 20px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #444445;
        line-height: 20px;
        letter-spacing: 0px;
    }
    .HeadTime a:first-child{
        font-weight: 600;
    }
</style>